export const MAX_ORGANIZATION_BRAND_LOGO_BYTES = 512 * 1024;
export const isSquareBrandLogo = (width, height) => width > 0 &&
    height > 0 &&
    Math.abs(width - height) <= Math.max(width, height) * 0.01;
const BRAND_LOGO_TYPE_PRIORITY = ['symbol', 'icon', 'logo'];
const rankIndex = (values, value) => {
    const index = value === null ? -1 : values.indexOf(value);
    return index === -1 ? values.length : index;
};
export const rankBrandLogos = (logos) => {
    const primary = logos.filter((logo) => logo.theme === 'dark' || logo.theme === null);
    return [...(primary.length > 0 ? primary : logos)].sort((a, b) => rankIndex(BRAND_LOGO_TYPE_PRIORITY, a.type) -
        rankIndex(BRAND_LOGO_TYPE_PRIORITY, b.type) ||
        rankIndex(['svg'], a.format) - rankIndex(['svg'], b.format));
};
export const pickBrandLogo = (logos) => rankBrandLogos(logos)[0] ?? null;
//# sourceMappingURL=organizationBrand.js.map